/**
 * Standalone entry for the account MFE when deployed to its own origin.
 * Ensures the federated module is in the bundle graph; direct visits show a short message.
 */
import { createRoot } from 'react-dom/client';

// Pull in the federated module so it is built and exposed via remoteEntry
import './federated-modules/smc-account-module';

const rootEl = document.getElementById('account-root');
if (rootEl) {
    const root = createRoot(rootEl);
    root.render(
        <div style={{ padding: '1rem', fontFamily: 'sans-serif' }}>
            Account MFE — load this remote from the Application Shell or main MFE.
        </div>
    );
}
